module.exports = __webpack_public_path__ + "static/media/FAQ_Header.274b382b.jpg";